import React from 'react';

const CalendarFill = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6931 2.88595V11.2542C12.6921 11.5954 12.5562 11.9223 12.315 12.1635C12.0737 12.4047 11.7469 12.5407 11.4057 12.5417H3.03743C2.69629 12.5407 2.3694 12.4047 2.12818 12.1635C1.88696 11.9223 1.751 11.5954 1.75 11.2542V2.88595C1.751 2.54481 1.88696 2.21793 2.12818 1.97671C2.3694 1.73548 2.69629 1.59952 3.03743 1.59853H4.03161V2.78582C4.03161 2.90912 4.08059 3.02737 4.16778 3.11456C4.25496 3.20174 4.37321 3.25073 4.49651 3.25073C4.61981 3.25073 4.73806 3.20174 4.82525 3.11456C4.91244 3.02737 4.96142 2.90912 4.96142 2.78582V1.59853H9.48172V2.78582C9.48172 2.90913 9.5307 3.02738 9.61789 3.11457C9.70508 3.20176 9.82334 3.25074 9.94665 3.25074C10.07 3.25074 10.1882 3.20176 10.2754 3.11457C10.3626 3.02738 10.4116 2.90913 10.4116 2.78582V1.59853H11.4057C11.7469 1.59953 12.0738 1.7355 12.315 1.97672C12.5562 2.21794 12.6921 2.54482 12.6931 2.88595Z"
      fill="currentColor"
    />
    <path
      d="M4.96173 1.33992V1.59741H4.03192V1.33992C4.03192 1.21662 4.0809 1.09837 4.16808 1.01119C4.25527 0.923999 4.37352 0.875018 4.49682 0.875018C4.62012 0.875018 4.73837 0.923999 4.82556 1.01119C4.91274 1.09837 4.96173 1.21662 4.96173 1.33992Z"
      fill="currentColor"
    />
    <path
      d="M10.4117 1.33992V1.59741H9.48194V1.33992C9.48194 1.21662 9.53092 1.09836 9.61811 1.01117C9.7053 0.923983 9.82356 0.875 9.94686 0.875C10.0702 0.875 10.1884 0.923983 10.2756 1.01117C10.3628 1.09836 10.4117 1.21662 10.4117 1.33992Z"
      fill="currentColor"
    />
    <path d="M5.23222 5.72217H4.27881V6.67558H5.23222V5.72217Z" fill="white" />
    <path d="M7.69906 5.72217H6.74565V6.67558H7.69906V5.72217Z" fill="white" />
    <path d="M10.1659 5.72217H9.21248V6.67558H10.1659V5.72217Z" fill="white" />
    <path d="M5.23222 8.4601H4.27881V9.41351H5.23222V8.4601Z" fill="white" />
    <path d="M7.69906 8.4601H6.74565V9.41351H7.69906V8.4601Z" fill="white" />
    <path d="M10.1659 8.4601H9.21248V9.41351H10.1659V8.4601Z" fill="white" />
    <path
      d="M5.23222 5.72217H4.27881V6.67558H5.23222V5.72217Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.69906 5.72217H6.74565V6.67558H7.69906V5.72217Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1659 5.72217H9.21248V6.67558H10.1659V5.72217Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.23222 8.4601H4.27881V9.41351H5.23222V8.4601Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.69906 8.4601H6.74565V9.41351H7.69906V8.4601Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1659 8.4601H9.21248V9.41351H10.1659V8.4601Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CalendarFill;
